import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { CustomAuthenticationService } from './custom-authentication.service';
import { AuthGroup } from './authorization.types';

@Injectable()
export class RoleGuardService implements CanActivate {
  constructor(
    protected router: Router,
    protected authorizationService: CustomAuthenticationService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const permissoes: Array<{name: string, type: string}> = route.data['auth'];
    let hasReqPermission = false
    for (let index = 0; index < permissoes.length; index++) {
      const permissao = permissoes[index];
      const hasPermisson = await this.hasRequiredPermission(permissao.name, permissao.type);
      if (hasPermisson === true) {
        hasReqPermission = true;
        break;
      }
    }
    if (hasReqPermission === false) {
      this.router.navigate(['home']);
      return hasReqPermission;
    }
    return hasReqPermission;
  }

  protected hasRequiredPermission(
    authGroup: AuthGroup,
    type: string
  ): Promise<boolean> | boolean {
    // If user’s permissions already retrieved from the API
    if (this.authorizationService.permissions) {
      if (authGroup && type) {
        const hasReqPermission = this.authorizationService.hasPermissionAndType(authGroup, type);
        return hasReqPermission;
      } else {
        return this.authorizationService.hasPermission(null);
      }
    } else {
      // Otherwise, must request permissions from the API first
      const promise = new Promise<boolean>((resolve, reject) => {
        this.authorizationService
          .initializePermissions()
          .then(() => {
            if (authGroup && type) {
              resolve(this.authorizationService.hasPermissionAndType(authGroup, type));
            } else {
              resolve(this.authorizationService.hasPermission(null));
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
      return promise;
    }
  }
}
